import Ext from "Ext";
import SelectorTreeNode from "./at_selector_tree_node";

/**
 * Selector tree checkbox node.
 *
 * Depends on:
 * <code>/js/controls/dateControls/at_selector_tree_node.js</code>
 *
 * @constructor
 * @cfg {String} label checkbox label.
 * @cfg {Object} item enclosed item (required).
 */
const SelectorTreeCheckbox = Ext.extend(SelectorTreeNode, {
    label: "",
    item: {},
    title: "",

    /**
     * @cfg {String} itemCls style class for the node body component.
     */
    itemCls: "at-selector-checkbox",

    /**
     * @cfg {String} itemCls style class for the node body component for inactive items.
     */
    itemInactiveCls: "at-selector-node-inactive",

    /**
     * @cfg {String} labelCls style class for the node body text label.
     */
    labelCls: "ellipsis",

    /**
     * @cfg {Boolean} specifies whether node's item is active or not
     */
    isActive: true,

    initComponent: function() {
        SelectorTreeCheckbox.superclass.initComponent.call(this);

        this.addEvents("change");
        this.nodeBody.on("check", this.onCheck, this);

        if (!this.isActive) {
            this.addClass(this.itemInactiveCls);
        }
    },

    /**
     * @see AT.SelectorTreeNode
     */
    getNodeBody: function() {
        var labelCls = this.labelCls;
        var title = this.title;
        return new Ext.form.Checkbox({
            cls: this.itemCls,
            boxLabel: this.createNodeLabel(this.item),
            checked: this.item[this.selectedProperty],
            afterRender: function() {
                Ext.form.Checkbox.prototype.afterRender.call(this);
                var label = Ext.get(this.el.dom.parentNode).child("label:first");
                if(title && title != "") label.dom.title = title;
                label.unselectable();
                label.addClass(labelCls);
            }
        });
    },

    createNodeLabel: function(item) {
        return Ext.util.Format.htmlEncode(this.label);
    },

    /**
     * Checkbox "check" event handler.
     * @param checkbox this.
     * @param {Boolean} checked checked state.
     * @private
     */
    onCheck: function(checkbox, checked) {
        this.select(checked);
        this.fireEvent("change", this, checked);
    },

    /**
     * @see AT.SelectorTreeNode
     */
    doSelect: function(value) {
        this.item[this.selectedProperty] = value;
        this.nodeBody.setValue(value);
        SelectorTreeCheckbox.superclass.doSelect.call(this, value);
    },

    /**
     * @see AT.SelectorTreeNode
     */
    filter: function(condition, scope) {
        var visible = condition.call(scope, this.item);
        this.setVisible(visible);
        this.item[this.hiddenProperty] = !visible;
        if (visible) {
            SelectorTreeCheckbox.superclass.filter.call(this, condition);
        }
    }
});

Ext.reg("at_selector_tree_checkbox", SelectorTreeCheckbox);

export default SelectorTreeCheckbox;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_selector_tree_checkbox.js